import { render, staticRenderFns } from "./MyProject.vue?vue&type=template&id=6291053c&scoped=true&"
import script from "./MyProject.vue?vue&type=script&lang=js&"
export * from "./MyProject.vue?vue&type=script&lang=js&"
import style0 from "./MyProject.vue?vue&type=style&index=0&id=6291053c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6291053c",
  null
  
)

export default component.exports